import { render } from "./CheckoutTotal.vue?vue&type=template&id=9c4309b0"
import script from "./CheckoutTotal.vue?vue&type=script&lang=js"
export * from "./CheckoutTotal.vue?vue&type=script&lang=js"

import "./CheckoutTotal.vue?vue&type=style&index=0&id=9c4309b0&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__